import { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector } from "redux-form";
import moment from "moment";

import "./styles.scss";

import Header from "components/organisms/header/index.jsx";
import Button from "components/atoms/button";
import ArrowLink from "components/atoms/arrowLink";
import FormContent from "components/organisms/formContent";
import FormActions from "components/molecules/formActions";
import FormCol from "components/molecules/formCol";
import FormFieldset from "components/molecules/formFieldset/index.jsx";
import RadioButtonGroup from "components/molecules/radioButtonGroup/index.jsx";
import RadioButton from "components/atoms/radioButton/index.jsx";
import Loader from "components/atoms/loader";
import WizardProgress from "components/organisms/wizard/progress";
import { fetchTimesheet } from "actions/models";
import { buildRequestObject } from "helpers/vehicle";
import validate from "../validate";

class ShiftHours extends Component {
  constructor(props) {
    super(props);

    this.state = {
      initialized: false,
      messageRead: props.brandId === 1 ? false : true,
    };
  }

  update() {
    const { vehicle, engine, transmission, traction, services, date, workshop } = this.props;

    const attributes = buildRequestObject({
      vehicle,
      engine,
      transmission,
      traction,
      services,
      date,
      workshop,
    });

    this.props.fetchTimesheet(attributes, this.props.brandId);
  }

  componentDidMount() {
    if (!this.state.initialized) {
      this.update();

      this.state.initialized = true;
    }
  }

  render() {
    const { hour, date, isFetching, timesheet, handleSubmit, brandId } = this.props;

    const momentDate = moment(date);

    return (
      <div className="shiftHours">
        <Header inFlow />
        <WizardProgress step="4" />
        <section className="stepContent">
          <div className="container">
            <div className="col">
              <h2>Agenda tu turno</h2>
              <p className="m">Elegí el horario para tu turno de caller.</p>

              {this.state.messageRead === false ? (
                <FormContent nomargins>
                  <FormCol single>
                    <FormFieldset first>
                      <p className="m noMaxWidth">
                        <strong>Preferencia horaria de recepción.</strong> Tené en cuenta que, según
                        la complejidad del trabajo, si tu vehículo ingresa después de las 12:00hs,
                        estará listo al día siguiente o cuando lo indique tu asesor en el momento de
                        la recepción.
                      </p>
                    </FormFieldset>
                  </FormCol>
                  <FormActions>
                    <Button type="button" buttonText="Aceptar" onClick={() => this.setState({ messageRead: true })} />
                  </FormActions>
                </FormContent>
              ) : (
                <form onSubmit={handleSubmit}>
                  <FormContent nomargins>
                    {isFetching && <Loader />}
                    {!isFetching && (
                      <FormCol third center>
                        <div className="selectedShift">
                          <div>
                            <br />
                            <h5 className="day">{momentDate.format("dddd")}</h5>
                            <h1>{momentDate.format("DD")}</h1>

                            <h4 className="month">{momentDate.format("MMMM YYYY")}</h4>

                            {/*<p className="hoursWarning">
                              Si traes tu vehículo a las {hour} hs, estará listo para retirar aproximadamente a las 17:30 hs.
                            </p>*/}
                            <p className="changeDate">
                              <ArrowLink onClick={this.props.previousPage}>Cambiar fecha</ArrowLink>
                            </p>
                          </div>
                        </div>
                      </FormCol>
                    )}
                    {!isFetching && (
                      <FormCol twothird>
                        <FormFieldset first>
                          <RadioButtonGroup
                            title="Selecciona uno de los horarios disponibles"
                            compact
                          >
                            {timesheet &&
                              timesheet.timetable.map((hour, i) => {
                                if (hour >= "13:00") {
                                  return;
                                }

                                return (
                                  <Field
                                    component={RadioButton}
                                    key={i}
                                    props={{ fieldValue: hour }}
                                    name="hour"
                                    inline
                                  >
                                    {hour} hs
                                  </Field>
                                );
                              })}
                          </RadioButtonGroup>
                          <RadioButtonGroup compact>
                            {timesheet &&
                              timesheet.timetable.map((hour, i) => {
                                if (hour < "13:00") {
                                  return;
                                }

                                return (
                                  <Field
                                    component={RadioButton}
                                    key={i}
                                    props={{ fieldValue: hour }}
                                    name="hour"
                                    inline
                                  >
                                    {hour} hs
                                  </Field>
                                );
                              })}
                          </RadioButtonGroup>
                        </FormFieldset>
                      </FormCol>
                    )}

                    <FormActions back={this.props.previousPage}>
                      <Button type="submit" buttonText="Continuar" disabled={!hour} />
                    </FormActions>
                  </FormContent>
                </form>
              )}
            </div>
          </div>
        </section>
      </div>
    );
  }
}

ShiftHours = reduxForm({
  form: "shiftRequest",
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(ShiftHours);

const selector = formValueSelector("shiftRequest");

ShiftHours = connect((state) => {
  return {
    vehicle: selector(state, "vehicle"),
    engine: selector(state, "engine"),
    transmission: selector(state, "transmission"),
    traction: selector(state, "traction"),
    services: selector(state, "services"),
    is_under_warranty: selector(state, "is_under_warranty"),
    date: selector(state, "date"),
    hour: selector(state, "hour"),
    workshop: selector(state, "workshop"),
  };
})(ShiftHours);

const mapStateToProps = (state) => {
  return {
    timesheet: state.models.timesheet,
    isFetching: state.models.isFetching,
    brandId: state.configuration.brand_id,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchTimesheet: (attributes, brandId) => {
      dispatch(fetchTimesheet(attributes, brandId));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShiftHours);
